// extracted by mini-css-extract-plugin
export default {"zoomImageWrapper":"style_zoomImageWrapper__5cvqE","zoomControl":"style_zoomControl__GsRhF","imageContainer":"style_imageContainer__HOC77","zoomedImage":"style_zoomedImage__sa220"};